var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1171275859(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#70A1E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5131 31.085C23.3633 31.1919 23.1839 31.2494 22.9998 31.2494C22.8157 31.2494 22.6363 31.1919 22.4865 31.085C18.0599 27.9298 13.362 21.4398 18.1112 16.7502C19.4146 15.4669 21.1707 14.7484 22.9998 14.75C24.8331 14.75 26.5922 15.4696 27.8884 16.7493C32.6376 21.4389 27.9397 27.928 23.5131 31.085Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 22.9999C23.4861 22.9999 23.9524 22.8068 24.2962 22.4629C24.64 22.1191 24.8332 21.6528 24.8332 21.1666C24.8332 20.6804 24.64 20.214 24.2962 19.8702C23.9524 19.5264 23.4861 19.3333 22.9998 19.3333C22.5136 19.3333 22.0473 19.5264 21.7035 19.8702C21.3597 20.214 21.1665 20.6804 21.1665 21.1666C21.1665 21.6528 21.3597 22.1191 21.7035 22.4629C22.0473 22.8068 22.5136 22.9999 22.9998 22.9999Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1171275859);
export default __webpack_public_path__ + "static/media/Frame 1171275859.613b288f6b4f79dd0de18c41c4878bd7.svg";
export { ForwardRef as ReactComponent };